
import { Options, Vue } from 'vue-class-component';
import apiConfig from "@/config/api";

//import {} from '@types/google.maps';
//import * as google from '@types/google.maps';

@Options({
    props: {
        google: {
            type: Object,
            required: true,
        },
        map: {
            type: Object,
            required: true,
        },
        lat: {
            type: Number,
            required: true,
        },
        lng: {
            type: Number,
            required: true,
        },
    },
    components: {

    },
    watch: {
        lat: {
            handler: 'positionChanged',
            immediate: false,
        },
        lng: {
            handler: 'positionChanged',
            immediate: false,
        },
    },
})
export default class UserMarker extends Vue {
    google!: any //google
    map!: any //google.maps.Map
    lat!: number
    lng!: number

    marker: any = null

    iconUrl = apiConfig.frontendAssetsUrl + '/img/markers/dark-green.png'

    handleClick() {
        this.$emit('click');
    }

    positionChanged() {
        this.marker.setPosition({ lat: this.lat, lng: this.lng });
    }

    mounted() {
        this.marker = new this.google.maps.Marker({
            position: { lat: this.lat, lng: this.lng },
            //marker: this.marker,
            map: this.map,
            icon: {
                url: this.iconUrl,
                scaledSize: new this.google.maps.Size(24, 35)
            },
            title: 'Standort',
            //animation: this.google.maps.Animation.DROP,
            clickable: false,
            //optimized: true,
        });

        //this.marker.addListener('click', this.handleClick);
    }

    beforeUnmount() {
        this.marker.setMap(null);
        this.marker = null;
    }
}
